import React from 'react';
import '../css/todolist.css';
import '../css/form.css';

const ToDoListTemplete = ({form, children}) => {
    return (
        <div className='body'>
            <header className='title'>
                TO DO List
            </header>

            <main className='todo-list-template'>
                <section className='form-wrapper'>
                    {form}
                </section>
                
                <section className='todos-wrapper'>
                    {children}
                </section>
            </main>
        </div>
    );
}

export default ToDoListTemplete;